import parse from 'html-react-parser';
import styles from './IncludeBlock.module.scss';
import {
  BaseText,
  EBaseTextPosition,
  EBaseTextSize,
  EBaseTextWeight,
} from '@spinwise/react-component-library/BaseText';
import Link from 'Components/shared/Link/Link';
import { EBrandTextColor } from 'Libraries/typography.library';
import { useDispatch } from 'react-redux';
import { OVERLAY_PROMOTION_SHOW } from '@spinwise/spinwise-core';
import { EComponentVisibility } from '@spinwise/react-component-library/Global';

export interface IIncludeBlock {
  title: string;
  description: string;
  item: any;
  btn_text: string;
  btn_url: string;
}

const IncludeBlock = (props: IIncludeBlock) => {
  const dispatch = useDispatch();

  const hidePromoOverlay = () => {
    dispatch({
      type: OVERLAY_PROMOTION_SHOW,
      content: {
        show: false,
      },
    });
  };

  return (
    <div className={styles.include_block}>
      <h2 className={styles.include_block__title}>{props?.title}</h2>
      <div className={styles.include_block__description}>{parse(props?.description)}</div>
      {props.item.map(el => {
        return (
          <div key={el?.id} className={`${styles.item_block} ai-c`}>
            <div className={`${EComponentVisibility.TableteDesktop}`}>
              <img
                src={el?.icon?.data?.attributes?.url}
                alt=""
                sizes="100vw"
                style={{ width: '225px', height: '265px' }}
              />
            </div>
            <div className={`${EComponentVisibility.MobileOnly}`} style={{ paddingBottom: '24px' }}>
              <img src={el?.mobile_icon?.data?.attributes?.url} alt="" style={{ width: '100%', height: '100%' }} />
            </div>
            <div className={styles.item_block__content}>
              {el?.btn_text && el?.btn_url ? (
                <>
                  <div className={styles.item_block__content_description}>{parse(el?.description)}</div>
                  <h3 className={styles.item_block__content_title}>{el?.title}</h3>
                  <Link href={el?.btn_url} onClick={() => hidePromoOverlay()}>
                    <BaseText
                      value={el?.btn_text}
                      weight={EBaseTextWeight.W500}
                      size={EBaseTextSize.Small}
                      color={EBrandTextColor.Violet}
                      alignment={EBaseTextPosition.Center}
                    ></BaseText>
                  </Link>
                </>
              ) : (
                <>
                  <h3 className={styles.item_block__content_title}>{el?.title}</h3>
                  <div className={styles.item_block__content_description}>{parse(el?.description)}</div>
                </>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default IncludeBlock;
